import { FC, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { taskRecords } from '@/common/api/expandStore/expansiontask';
import styles from '../index.module.less';
import { Button } from 'antd';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import CreateCommunicationRecord from './CreateCommRecord';
import MeetCard from './MeetCard';
import V2Empty from '@/common/components/Data/V2Empty';

/**
 * 拓店任务-详情-沟通记录
 * @Description
 * 拓店任务：直营-详情
 * 目前看来卡旺卡和普通拓店任务处理无差异 src/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/components/DetailMain/components/Meet.tsx
 */
const Meet: FC<{
  /** 任务id */
  id: number;
  /** 是否只能查看（审批详情时只能查看） */
  isView: boolean;
  /** 外部新增按钮是否可见 */
  showAddBtn?: boolean;
  /** 展示外部的新增沟通记录按钮文案，为空则不展示按钮 */
  setAddMeetButtonText?,
  ref?: any,
}> = forwardRef(({
  id, // 任务id
  isView, // 是否只能查看（审批详情时只能查看）
  showAddBtn = true,
  setAddMeetButtonText,
}, ref) => {

  useImperativeHandle(ref, () => ({
    addCommunicationRecord: methods.addCommunicationRecord,
  }));

  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [meetList, setMeetList] = useState<any>([]);
  const [refreshFlag, setRefreshFlag] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  /** 展示内部列表上方的新增按钮 */
  const showInnerAddButton = !isView && showAddBtn && !!meetList.length;

  useEffect(() => {
    methods.getTaskRecords();
  }, [id, refreshFlag]);
  useEffect(() => {
    // 为了和内部显示逻辑统一
    setAddMeetButtonText?.(meetList?.length ? '新增沟通纪要' : '');
  }, [meetList]);

  const methods = useMethods({

    /** 点击新增 */
    onClickAdd: () => {
      // 限制20条记录
      if (meetList.length >= 20) {
        V2Confirm({ onSure: (modal: any) => modal.destroy(), content: '沟通记录已达20次上限~', noFooter: true });
        return;
      }

      setShowCreateModal(true);
    },

    /** 新增沟通记录 */
    addCommunicationRecord: () => {
      setShowCreateModal(true);
    },

    /** 获取沟通记录 */
    getTaskRecords: async() => {
      const data = await taskRecords({ id });
      setMeetList(data);
      setIsLoading(false);
    },

  });

  return (
    <>
      {isLoading ? <></> : <div className={styles.communication}>
        {!!showInnerAddButton && <span className={styles.addcommunication} onClick={methods.onClickAdd}>+ 新增沟通纪要</span>}
        {(isArray(meetList) && meetList.length > 0)
          ? meetList.map((item, index) => <MeetCard detail={item} key={index}/>)
          : <V2Empty
            className='mt-100'
            customTip={!isView
              ? <Button onClick={methods.addCommunicationRecord} type='primary'>新增沟通纪要</Button>
              : '暂无记录'}
          />}
      </div>}

      {/* 新建沟通记录 */}
      <CreateCommunicationRecord
        id={id}
        refresh={() => setRefreshFlag((state) => state + 1)}
        open={showCreateModal}
        setOpen={setShowCreateModal}
        num={isArray(meetList) ? meetList.length : 0}
      />
    </>

  );
});
export default Meet;
